import React from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  Skeleton,
  Typography,
} from "@mui/material";

import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function CaseCard({ img, title, description, tags, onClick }) {
  tags.sort((a, b) => b.length - a.length);
  return (
    <Card
      sx={{
        height: { xs: "auto", sm: "600px", md: "600px" },
        width: "auto",
        padding: "20px",
        gap: "20",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      style={{
        borderRadius: "16px",
        border: "0.952px solid #E3E3E4",
      }}
    >
      <Grid container spacing={1} sx={{ alignItems: "center" }}>
        <Grid item xs={12} position="relative">
          <CardMedia
            component="img"
            height="134"
            width="280"
            image={img}
            loading="lazy"
            decoding="sync"
            alt=""
            sx={{
              borderRadius: "6.57px",
              backgroundColor: "black",
              objectFit: "contain",
            }}
          />
          <Box position="absolute" top={0} left={0} p={1.5} borderRadius="4px">
            <Box
              sx={{
                display: "inline-flex",
                padding: "2px 8px 2px 5px",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                borderRadius: "40px",
                border: "1px solid #000",
                background: "#FFF",
              }}
            >
              <LocalOfferIcon
                sx={{
                  width: "10.833px",
                  height: "10.833px",
                  fill: "#000",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "#000",
                  textAlign: "center",
                  fontFamily: "Source Sans Pro",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "normal",
                  letterSpacing: "-0.36px",
                }}
              >
                Cases
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <CardContent
          sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
          style={{ padding: "10px" }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              overflowWrap: "break-word",

              height: "auto",
              gap: "15.24px",
            }}
          >
            {title === "" ? (
              <Skeleton
                variant="rectangular"
                width="70%"
                style={{ paddingTop: "5px" }}
              />
            ) : (
              <Typography
                style={{ width: "100%" }}
                sx={{
                  fontSize: "20px !important",
                  color: "black",
                  fontFamily: "Source Sans Pro !important",
                  fontWeight: "600 !important",
                  letterSpacing: "-0.4 !important",
                  lineHeight: "normal !important",
                  height: { xs: "auto", sm: "85px", md: "85px" },
                  fontStyle: "normal",
                }}
              >
                {title}
              </Typography>
            )}
            {description ? (
              <Typography
                style={{
                  width: "100%",
                  display: "-webkit-box",
                  WebkitLineClamp: "4",
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                }}
                sx={{
                  fontSize: "16px !important",
                  color: "black",
                  fontFamily: "Source Sans Pro !important",
                  fontWeight: "400 !important",
                  lineHeight: "normal !important",
                  fontStyle: "normal !important",
                  height: { xs: "auto", sm: "85px", md: "85px" },
                }}
              >
                <p
                  style={{
                    fontSize: "16px",
                    color: "#000",
                    fontFamily: "Source Sans Pro",
                    fontWeight: "400",
                    lineHeight: "normal",
                    fontStyle: "normal",
                    letterSpacing: "0.00938em",
                  }}
                >
                  {description}
                </p>
              </Typography>
            ) : (
              ""
            )}
            {tags ? (
              <Typography style={{ width: "100%" }}>
                <Typography
                  variant="body2"
                  style={{
                    width: "100%",
                    paddingBottom: 5,
                    flexShrink: 0,
                    textAlign: "left",
                    color: "black",
                    fontFamily: "Source Sans Pro",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "normal",
                    fontStyle: "normal",
                    marginTop: "8px",
                  }}
                >
                  <b>Tags:</b>
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0.5,
                    flexDirection: "row",
                    alignItems: "flex-start",
                  }}
                >
                  {tags.map((label, index) => (
                    <Chip
                      key={index}
                      label={label}
                      sx={{
                        border: "1px solid black",
                        backgroundColor: "#D4D3D4;",
                        borderWidth: "1",
                        borderColor: "black",
                        borderRadius: "50",
                        color: "black",
                        fontFamily: "Source Sans Pro",
                        fontSize: "14px",
                        fontWeight: "400",
                        letterSpacing: "-0.42 px",
                        lineHeight: "normal",
                        gap: "4px",
                        fontStyle: "normal",
                        "&.MuiChip-root .MuiChip-label": {
                          paddingLeft: "10px",
                          paddingRight: "10px",
                        },
                      }}
                    />
                  ))}
                </Box>
              </Typography>
            ) : (
              ""
            )}
          </Box>
        </CardContent>
      </Grid>
      <CardActions
        sx={{
          marginTop: "auto",
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
          flex: 1,
        }}
      >
        <Button
          variant="contained"
          style={{
            width: "auto",
            height: "44px",
            textTransform: "none",
            backgroundColor: "#6022A6",
            alignSelf: "center",
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "12px 16px",
          }}
          size="large"
          onClick={onClick}
        >
          <Typography
            style={{
              fontFamily: "Source Sans Pro",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "normal",
              letterSpacing: "-0.48px",

              fontStyle: "normal",
            }}
          >
            View this case
          </Typography>
          <ChevronRightIcon fontSize="small" />
        </Button>
      </CardActions>
    </Card>
  );
}

export default CaseCard;
